import actions from './actions';
import mutations from './mutations';
import getters from './getters';
const state = {
    messages: [],
    show_all: false
};
export default {
    state,
    mutations,
    actions,
    getters
};
